import { useEffect } from 'react';

export const useAutoScroll = (pageKey?: string) => {
  useEffect(() => {
    (document.scrollingElement || document.body).scroll({ top: 0 });
  }, [pageKey]);
};
